module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBold.48199c4c.woff";